export default __webpack_public_path__ + "static/tag-do-2-dark-7011d9c89f460740ce15a24fe4f32f88817a043687851cdc5d17804b9ae6be07.png";